/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react'
import { TextField } from '@mui/material'
import useStyles from './styles'
interface Props {
  label: string
  placeHolder?: string
  id?: string
  name?: string
  value?: any
  type?: string
  disabled?: boolean
  onChangeHandler?: (
    e: React.ChangeEvent<any>
  ) =>
    | void
    | React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>
    | React.SyntheticEvent
  error?: boolean
  helperText?: string | false | undefined
}

const CustomTextField = ({
  label,
  placeHolder,
  id,
  name,
  type = 'text',
  value,
  onChangeHandler,
  error,
  helperText,
  disabled,
}: Props) => {
  const { classes } = useStyles()
  return (
    <div className={classes.root}>
      <TextField
        fullWidth
        aria-label={name || ''}
        id={id || ''}
        name={name || ''}
        type={type}
        label={label}
        variant="filled"
        placeholder={placeHolder || ''}
        value={value}
        onChange={onChangeHandler}
        error={error || false}
        helperText={helperText || ''}
        className={classes.formTextfield}
        disabled={disabled}
      />
    </div>
  )
}

export default CustomTextField
